import { render, staticRenderFns } from "./bussetting-menushow.vue?vue&type=template&id=67706390&scoped=true&"
import script from "./bussetting-menushow.vue?vue&type=script&lang=js&"
export * from "./bussetting-menushow.vue?vue&type=script&lang=js&"
import style0 from "./bussetting-menushow.vue?vue&type=style&index=0&id=67706390&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67706390",
  null
  
)

export default component.exports